export const AuthorityMenu = (notificationCount) => [
  {
    title: "Dashboard",
    url: "/authority/dashboard",
    icon: "pi pi-th-large"
  },
  {
    title: (
      <>
        Notifications
        {notificationCount != 0 && <span className="notification-count">{notificationCount}</span>}
      </>
    ),
    url: "/notification",
    icon: "pi pi-bell"
  },
  {
    title: "Authority User",
    url: "/authority/user",
    icon: "pi pi-user"
  },
  {
    title: "Cases List",
    url: "/authority/case/list",
    icon: "pi pi-home"
  }
];
